import { Component } from '@angular/core';

@Component({
    selector: 'app-loginwebapp',
    templateUrl: './loginwebapp.component.html',
    standalone: false
})
export class LoginwebappComponent {

}
